<template>
  <div v-if="open || inline" class="cal" :class="{ 'cal-inline': inline }">
    <div class="cal-panel" role="dialog" aria-label="Rango de fechas">
      <div class="cal-head">
        <button type="button" aria-label="Mes anterior" @click="move(-1)">‹</button>
        <p>{{ month.title }}</p>
        <button type="button" aria-label="Mes siguiente" @click="move(1)">›</button>
      </div>
      <div class="cal-week">
        <span v-for="day in month.weekdays" :key="day">{{ day }}</span>
      </div>
      <div class="cal-grid">
        <button
          v-for="day in month.days"
          :key="day.iso"
          type="button"
          class="cal-day"
          :class="{
            'is-out': !day.inMonth,
            'is-start': day.iso === inicio || day.iso === fin,
            'is-range': inRange(day.iso, inicio, fin),
          }"
          @click="pick(day.iso)"
        >
          {{ day.label }}
        </button>
      </div>
      <p class="cal-hint">{{ hint }}</p>
      <button type="button" class="cal-apply" :disabled="!inicio || !fin" @click="apply">
        Aplicar
      </button>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { buildMonth, inRange } from '@/dashboard/calendar'

export default {
  name: 'RangeCalendar',
  props: {
    open: { type: Boolean, default: false },
    // Incrustado en otro panel (sin posición absoluta, borde ni sombra propios)
    inline: { type: Boolean, default: false },
    active: { type: Boolean, default: false },
    inicio: { type: String, default: '' },
    fin: { type: String, default: '' },
  },
  data() {
    return {
      // Abre en el mes del rango elegido para no navegar desde hoy
      cursor: (this.inicio ? moment(this.inicio) : moment()).startOf('month').toDate(),
    }
  },
  computed: {
    month() {
      return buildMonth(this.cursor)
    },
    hint() {
      if (!this.inicio) return 'Elige el primer día'
      if (!this.fin) return 'Elige el último día'
      return 'Rango listo'
    },
  },
  methods: {
    inRange,
    move(step) {
      this.cursor = moment(this.cursor).add(step, 'month').toDate()
    },
    pick(iso) {
      if (!this.inicio || this.fin) {
        this.$emit('pick', { inicio: iso, fin: '' })
        return
      }
      if (iso < this.inicio) {
        this.$emit('pick', { inicio: iso, fin: this.inicio })
        return
      }
      this.$emit('pick', { inicio: this.inicio, fin: iso })
    },
    apply() {
      if (!this.inicio || !this.fin) return
      this.$emit('apply')
    },
  },
}
</script>

<style scoped>
.cal {
  position: absolute;
  right: 0;
  z-index: 30;
  font-family: Roboto, "Open Sans", sans-serif;
}
.cal-inline {
  position: static;
}
.cal-inline .cal-panel {
  position: static;
  margin: 0;
  padding: 0;
  border: 0;
  box-shadow: none;
}
.cal-panel {
  position: absolute;
  right: 0;
  z-index: 30;
  width: 280px;
  margin-top: 8px;
  padding: 12px;
  border: 1px solid #e6ebf2;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 12px 32px rgba(7, 40, 77, 0.16);
}
.cal-head,
.cal-week,
.cal-grid {
  display: grid;
}
.cal-head {
  grid-template-columns: 32px 1fr 32px;
  align-items: center;
}
.cal-head p {
  margin: 0;
  text-align: center;
  font-size: 15px;
  font-weight: 700;
  text-transform: capitalize;
  color: #07284d;
}
.cal-head button,
.cal-day {
  border: 0;
  background: transparent;
  color: #07284d;
  font-family: inherit;
  cursor: pointer;
}
.cal-head button {
  height: 32px;
  border-radius: 8px;
  font-size: 20px;
}
.cal-week,
.cal-grid {
  grid-template-columns: repeat(7, 1fr);
}
.cal-week {
  margin-top: 8px;
}
.cal-week span {
  text-align: center;
  font-size: 14px;
  font-weight: 700;
  color: #7b8798;
}
.cal-day {
  height: 44px;
  margin-top: 2px;
  border-radius: 8px;
  font-size: 14px;
}
.cal-day.is-out {
  color: #b7c3d1;
}
.cal-day.is-range {
  background: #e7f0fa;
  border-radius: 0;
}
.cal-day.is-start {
  background: #0a4f9c;
  color: #fff;
  border-radius: 8px;
  font-weight: 700;
}
.cal-hint {
  margin: 10px 0 0;
  font-size: 13px;
  color: #5c6b80;
}
.cal-apply {
  width: 100%;
  height: 40px;
  margin-top: 8px;
  border: 0;
  border-radius: 10px;
  background: #0a4f9c;
  color: #fff;
  font-family: inherit;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
}
.cal-apply:disabled {
  cursor: not-allowed;
  background: #9bb6d4;
}
</style>
